import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Label,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import { FONTS, COLORS } from '../../../constants'
import "../../../static/css/index.css"

class CompensateRequestPreview extends React.Component {
  render() {
    const newCompensateRequest = get(this.props, 'newCompensateRequest')
    const createdCompensatePreview = get(this.props, 'createdCompensatePreview')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'showCompensatePreview') }
        toggle={ get(this.props, 'handleCloseRequest') }
      >
        <ModalHeader
          toggle={ get(this.props, 'handleCloseRequest') }
        >
          <HeadModal>
            Compensate Work Request
          </HeadModal>
        </ModalHeader>
        <ModalBody>
          { get(newCompensateRequest, 'project_id.label') &&
            <div>
              <LabelTextPreview>Project</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(newCompensateRequest, 'project_id.label') }
                </ColData>
              </Row>
            </div>
          }
          { get(newCompensateRequest, 'start_date') &&
            <div>
              <LabelTextPreview>Compensate Work Date</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { moment(get(newCompensateRequest, 'start_date')).format('DD/MM/YYYY') } - { moment(get(newCompensateRequest, 'end_date')).format('DD/MM/YYYY') }
                </ColData>
              </Row>
            </div>
          }
          { get(newCompensateRequest, 'working_time') &&
            <div>
              <LabelTextPreview>Working Time</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(newCompensateRequest, 'working_time') }
                </ColData>
              </Row>
            </div>
          }
          { get(createdCompensatePreview, 'days') &&
            <div>
              <LabelTextPreview>Total Compensate Work Day</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(createdCompensatePreview, 'days') }
                </ColData>
              </Row>
            </div>
          }
          { get(newCompensateRequest, 'approver_id.label') &&
            <div>
              <LabelTextPreview>Approver</LabelTextPreview>
              <Row noGutters>
                <ColData>
                  { get(newCompensateRequest, 'approver_id.label') }
                </ColData>
              </Row>
            </div>
          }
          { get(newCompensateRequest, 'remark', '') !== '' &&
            <div>
              <LabelTextPreview>Remarks</LabelTextPreview>
              <Row>
                <ColData>
                  { get(newCompensateRequest, 'remark') }
                </ColData>
              </Row>
            </div>
          }
        </ModalBody>
        <ModalFooter style={ { borderTop: 'none' } } >
          <div>
            <CustomButton
              style={ {
                backgroundColor: '#FFFFFF',
                border: '1px solid #CCCCCC',
                color: '#000000',
                marginRight: '5px',
              } }
              onClick={ get(this.props, 'handleBack') }
            >Back</CustomButton>
            <CustomButton
              color="success"
              onClick={ get(this.props, 'clickConfirmCompensate') }
            >Confirm</CustomButton>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

export default CompensateRequestPreview

const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  height: 40px;
  width: fit-content;
  padding-top: 0px;
  padding-bottom: 0px;
`
const LabelTextPreview = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 2%;
  margin-bottom: 0%;
`
const HeadModal = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  margin: 0px;
  color: ${COLORS.PRIMARY_RED};
  font-size: ${FONTS.TITLE_SIZE};
`
const ColData = styled(Col)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`




// WEBPACK FOOTER //
// ./src/components/my-leave/form/compensate-preview.js